<template>
  <div class="login">
    <img src="../assets/imgs/logo.png" alt="" class="logo_mask">
    <div class="back_btn" @click="$router.push('/')">返回首页</div>
    <div class="text_mask">
      <p>欢迎登录中铁桥隧招标网</p>
      <p><span>及时高效</span>查找招标信息</p>
    </div>
    <div class="login_form">
      <p>登录</p>
      <Form ref="form" :model="form" :rules="formRule">
        <FormItem prop="name">
          <Input type="text" v-model="form.name" placeholder="用户名" class="form_account">
            <div slot="prefix" class="icon_prefix">
              <img src="@/assets/imgs/user.png" alt="">
            </div>
          </Input>
        </FormItem>
        <FormItem prop="pwd">
          <Input type="password" v-model="form.pwd" placeholder="密码" class="form_pass">
            <div slot="prefix" class="icon_prefix">
              <img src="@/assets/imgs/lock.png" alt="">
            </div>
          </Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('form')" long>登录</Button>
          <div class="register">
            <span @click="$router.push('register')">立即注册</span>
            <span @click="modal=true">忘记密码</span>
          </div>
        </FormItem>
      </Form>
    </div>
    <div class="footer">Copyright © 2021中铁桥隧技术有限公司【苏ICP备15036412号-3】</div>
    <Modal v-model="modal" title="请输入公司名称" :mask-closable='false'>
      <Input v-model="unitName" placeholder="请输入公司名称" />
      <span style="color:#86888c">我们将会为此公司下注册的邮箱发送修改密码邮件,请注意查收</span>
      <div slot="footer" class="modal_footer">
        <Button @click="modal = false">取消</Button>
        <Button type="primary" @click="changePwd">确认</Button>
      </div>
    </Modal>
    <ChangePwd ref="changePwd" :show="false"></ChangePwd>
  </div>
</template>
<script>
import ChangePwd from '@/components/ChangePwd'
import { validatePassword } from '@/utils/valide.js'
import { login,forgetPwd } from '@/api/api'
export default {
  components: {
    ChangePwd
  },
  data() {
    return {
      form: {
        name: '',
        pwd: ''
      },
      formRule: {
        name: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ]
      },
      modal:false,
      unitName:''
    }
  },
  created() {
    if(this.$route.query.token){
      sessionStorage.setItem("token", this.$route.query.token)
      this.$nextTick(() => {
        this.$refs['changePwd'].modal = true
      })
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          const obj = {
            name: this.form.name,
            pwd: window.btoa(this.form.pwd)
          }
          login(obj).then(res => {
            this.$store.commit('saveLoginInfo',res)
            this.$Message.success('登录成功!')
            this.$router.push('/systemHome')
          }).catch(err => console.log(err))
        } else {
          this.$Message.error('请填写用户名/密码!');
        }
      })
    },
    changePwd() {
      forgetPwd(this.unitName).then(res => {
        this.modal = false
      }).catch(err => console.log(err))
    }
  }
}
</script>
<style lang='scss' scoped>
  .login {
    position: relative;
    width: 100%;
    height: 100vh;
    background: url('../assets/imgs/login_back.png') no-repeat center 0;
    .logo_mask {
      position: absolute;
      top: 50px;
      left: 80px;
    }
    .back_btn {
      position: absolute;
      top: 67px;
      right: 80px;
      font-size: 20px;
      font-weight: bold;
      color: #FBFBFB;
      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
    .text_mask {
      position: absolute;
      top: 25%;
      left: 280px;
      font-weight: bold;
      color: #FBFBFB;
      line-height: 80px;
      p:first-child {
        font-size: 46px;
      }
      p:nth-child(2) {
        font-size: 34px;
        span {
          color: #F5DA24;
        }
      }
    }
    .login_form {
      position: absolute;
      width: 460px;
      height: 448px;
      top: 25%;
      right: 220px;
      background-color: rgba(255,255,255,0.5);
      p {
        font-size: 27px;
        color: #006DC8;
        line-height: 126px;
        text-align: center;
      }
      .ivu-form {
        margin: 0 50px;
        ::v-deep .ivu-input{
          height: 50px;
          padding-left: 60px;
        }
        ::v-deep .icon_prefix {
          padding: 15px 0;
          img {
            padding: 0 12px;
            border-right: 1px solid #D7D7D7;
          }
        }
        ::v-deep .ivu-btn {
          height: 50px;
          margin-top: 30px;
        }
        ::v-deep .register {
          font-size: 18px;
          color: #006DC8;
          margin-top: 18px;
          display: flex;
          justify-content: space-between;
          span:hover {
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }
    }
    .footer {
      position: absolute;
      bottom: 0;
      display: inline-block;
      text-align: center;
      width: 100%;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 24px;
    }
  }
</style>
